import { createSignalRConnection, startConnection,  } from "./signalRConnectionTracking";

import store from "../../store/store"
import { addLiveLocationDataToTrackingShipmentItemLocationList } from "../../features/topPagesMap/topPagesMapSlice";

const connectionOnTracking = async () => {

    const connection = createSignalRConnection()
    await startConnection(connection)
    
    //! liveBosaltmadaLocation
    connection.on('trackShipment', (data) => {
        store.dispatch(addLiveLocationDataToTrackingShipmentItemLocationList ({
            ...data,
            // createdDate: data.createdDate
            createdDate: data.createdDate
        }))
    });

    //! portal.kamyoon.com.tr/sefer-takip/772e3f64-5a4b-4ace-9e5c-e31748695879
    
}

export default connectionOnTracking